module.exports = __webpack_public_path__ + "img/5.879d54d0.jpg";